:host {
  display: flex;
  flex-direction: column;
  gap: var(--klevu-spacing-04);
  word-break: break-word;
}

.message-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.feedback {
  display: flex;
}

.feedback klevu-icon {
  font-size: 22px;
  padding: 6px;
  cursor: pointer;
  position: relative;
}

.feedback klevu-icon:first-child {
  color: var(--klevu-color-positive);
}

.feedback klevu-icon:last-child {
  color: var(--klevu-color-negative);
}

.feedback-hide {
  opacity: 0;
}

.end-spacer {
  height: var(--klevu-spacing-04);
  width: 100%;
  display: var(--end-spacer-display);
}

.filteractions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--klevu-spacing-02);
}

.productactions {
  display: flex;
  flex-direction: column;
  gap: var(--klevu-spacing-02);
}

a {
  color: var(--klevu-chat-bubble-text-color-remote, var(--klevu-color-neutral-1));
}

klevu-product {
  --klevu-product-details-spacing: 1px;
}
klevu-button {
  --klevu-button-cursor-hover: pointer;
}
